<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">User Search</h4>
          <a *ngIf="CanCreate" class='btn btn-success' routerLink="/Auth/UserProfile/New" role="button" id="btnCreate">
            Create
          </a>

          <app-ngbAccordion class="m-t-10" headerName="Search Criteria">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>User Account</label>
                  <input type="text" id="txtUserAccount" class="form-control"
                    [(ngModel)]="model.filter.UserAccount" placeholder="">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>IsEnabled</label>
                  <ng-select [searchable]="false" [items]="model.ddlIsEnabled" bindValue="value" bindLabel="text"
                    [clearable]="false" [(ngModel)]="model.filter.IsEnabled">
                  </ng-select>
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-secondary"
              (click)="this.model.filter.PageIndex = 1;Search()">Search</button>
          </app-ngbAccordion>

          <app-ngbAccordion class="m-t-10" headerName="Search Result">
            <div>
              <div class="rowCard">
                <app-table-pager [Income]=TableData (PageInfo)="onChangePageInfo($event)"></app-table-pager>
              </div>
              <app-table [Income]=TableData [TableSetting]=TableSetting (DeleteEvent)="Delete($event)"
                (TableInfo)="onChangeTableInfo($event)">
              </app-table>
              <div class="dataTb">
                <app-table-pager [Income]=TableData (PageInfo)="onChangePageInfo($event)"></app-table-pager>
              </div>
            </div>
          </app-ngbAccordion>
        </div>
      </div>
    </div>
    <footer class="footer text-center"></footer>
  </div>
</div>
